import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterForm", "validationMessage", "clientHint", "filtersWrapper",
                     "countCell", "pctCell", "toggleCounts", "togglePcts"]

  connect() {
    this.showingCounts = true
    this.updateToggleStyles()
  }

  filterChanged(event) {
    const changedFilter = event.target.dataset.filterName
    const form = this.filterFormTarget

    if (changedFilter === "client") this.hideValidationError()

    this.clearDependentFilters(changedFilter)

    const formData = new FormData(form)
    const params = new URLSearchParams(formData)
    params.set("changed_filter", changedFilter)

    const url = `/distribution_overview/filter_options?${params.toString()}`

    fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)

      if (changedFilter === "client") {
        const hasClient = event.target.value !== ""
        if (this.hasClientHintTarget) this.clientHintTarget.classList.toggle("hidden", hasClient)
        if (this.hasFiltersWrapperTarget) {
          this.filtersWrapperTarget.classList.toggle("opacity-40", !hasClient)
          this.filtersWrapperTarget.classList.toggle("pointer-events-none", !hasClient)
          this.filtersWrapperTarget.classList.toggle("select-none", !hasClient)
        }
      }
    })
  }

  generateReport(event) {
    event.preventDefault()
    const clientSelect = this.filterFormTarget.querySelector('[name="client_id"]')
    if (!clientSelect || !clientSelect.value) {
      this.showValidationError("Please select a client before generating the report.")
      return
    }
    this.hideValidationError()
    this.filterFormTarget.requestSubmit()
  }

  showCounts() {
    this.showingCounts = true
    this.countCellTargets.forEach(el => el.classList.remove("hidden"))
    this.pctCellTargets.forEach(el => el.classList.add("hidden"))
    this.updateToggleStyles()
  }

  showPercentages() {
    this.showingCounts = false
    this.countCellTargets.forEach(el => el.classList.add("hidden"))
    this.pctCellTargets.forEach(el => el.classList.remove("hidden"))
    this.updateToggleStyles()
  }

  updateToggleStyles() {
    if (!this.hasToggleCountsTarget) return

    const activeClass = "bg-sapphire text-white border-sapphire"
    const inactiveClass = "bg-white text-gray-600 border-gray-300 hover:bg-gray-50"

    const countsBtn = this.toggleCountsTarget
    const pctsBtn = this.togglePctsTarget

    if (this.showingCounts) {
      countsBtn.className = `px-2 py-0.5 text-xs font-medium rounded border transition-colors ${activeClass}`
      pctsBtn.className = `px-2 py-0.5 text-xs font-medium rounded border transition-colors ${inactiveClass}`
    } else {
      countsBtn.className = `px-2 py-0.5 text-xs font-medium rounded border transition-colors ${inactiveClass}`
      pctsBtn.className = `px-2 py-0.5 text-xs font-medium rounded border transition-colors ${activeClass}`
    }
  }

  showValidationError(message) {
    if (!this.hasValidationMessageTarget) return
    this.validationMessageTarget.textContent = message
    this.validationMessageTarget.classList.remove("hidden")
  }

  hideValidationError() {
    if (!this.hasValidationMessageTarget) return
    this.validationMessageTarget.classList.add("hidden")
  }

  clearDependentFilters(changedFilter) {
    const hierarchy = {
      "client": ["brand_id", "ph1_id", "ph2_id", "ph3_id", "retailer_id", "banner_id", "place_owner_id[]"],
      "ph1": ["ph2_id", "ph3_id"],
      "ph2": ["ph3_id"],
      "retailer": ["banner_id", "place_owner_id[]"]
    }

    const toClear = hierarchy[changedFilter] || []
    toClear.forEach(fieldName => {
      const field = this.filterFormTarget.querySelector(`[name="${fieldName}"]`)
      if (field) {
        if (field.multiple) {
          Array.from(field.options).forEach(opt => opt.selected = false)
          field.dispatchEvent(new Event("change"))
        } else {
          field.value = ""
        }
      }
    })
  }
}
